import { render, staticRenderFns } from "./NewsChild.vue?vue&type=template&id=65aefc5b&"
import script from "./NewsChild.vue?vue&type=script&lang=js&"
export * from "./NewsChild.vue?vue&type=script&lang=js&"
import style0 from "./NewsChild.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports